<template>
  <div > 
    <b-form @submit="store">
        <div class="row justify-content-center" style="background:#f6f6f6;">
            <div class="col-md-12 col-11" >
               <div class="row justify-content-center" style="background:#019DF4;">
                 <div class="col-md-12">
                    <br> 
                    <br>
                 </div>  
              </div>
              <div class="row justify-content-center" >
                <div class="col-md-10 mt-5" > 
                    <div class="row justify-content-center mt-5">
                        <div class="col-md-4">
                           <label for="" style="font-size: 17px;" :class="isMobile ? 'ml-5' : 'ml-5'">Tipo de solicitud:</label>
                              <select class="form-control" aria-label="Default select example" v-model="tipo_solicitud" style="border-radius: 30px; background: #fff; border: 1px solid #ccc; font-size: 17px;">
                                <option value="" selected>Selecciona un estado</option>
                                <option value="Reactivar IDPDV">Reactivar IDPDV</option>
                                <option value="Suspender IDPDV">Suspender IDPDV</option>
                                <option value="Reasignar DI al IDPDV">Reasignar DI al IDPDV</option> 
                                <option value="Baja definitiva">Baja definitiva</option>
                            </select> 
                           <!-- <b-form-input placeholder="Escribe aquí" v-model="estado" class="form-control form-control-lg"  type="text" style="border-radius: 30px; background: transparent; border: 1px solid #ccc; font-size: 17px;"/> -->
                            <small v-if="errors.includes('tipo_solicitud')" class="text-danger mt-2 text-left">
                                <i class="fas fa-exclamation-circle"></i>
                                Este campo es obligatorio
                            </small> 
                        </div>
                        <div class="col-md-4">
                           <label for="" style="font-size: 17px;" :class="isMobile ? 'mt-5 ml-5' : 'ml-5'">IDPDV:</label>
                           <b-form-input placeholder="Escribe aquí" v-model="idpdv" class="form-control form-control-lg"  oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" type="text" style="border-radius: 30px; background: #fff; border: 1px solid #ccc; font-size: 17px;"/>
                           <small v-if="errors.includes('idpdv')" class="text-danger mt-2 text-left">
                                <i class="fas fa-exclamation-circle"></i>
                                Este campo es obligatorio
                            </small> 
                        </div>
                        <div class="col-md-4">
                           <label for="" style="font-size: 17px;"  :class="isMobile ? 'mt-5 ml-5' : 'ml-5'">Nombre de IDPDV:</label>
                           <b-form-input placeholder="Escribe aquí" v-model="nombre_idpdv" class="form-control form-control-lg"  type="text" style="border-radius: 30px; background: #fff; border: 1px solid #ccc; font-size: 17px;"/>
                           <small v-if="errors.includes('nombre_idpdv')" class="text-danger mt-2 text-left">
                                <i class="fas fa-exclamation-circle"></i>
                                Este campo es obligatorio
                            </small> 
                        </div>
                        <div :class="isMobile ? 'col-md-3' : 'col-md-3 mt-5'" v-if="tipo_solicitud == 'Reasignar DI al IDPDV'">
                           <label for="" style="font-size: 17px;" :class="isMobile ? 'mt-5 ml-5' : 'mt-5 ml-5'">DI Actual:</label>
                           <b-form-input placeholder="000000" v-model="di" class="form-control form-control-lg" maxlength="6" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" type="text" style="border-radius: 30px; background: #fff; border: 1px solid #ccc; font-size: 17px;"/>
                            <small v-if="errors.includes('di')" class="text-danger mt-2 text-left">
                                <i class="fas fa-exclamation-circle"></i>
                                Este campo es obligatorio
                            </small> <br v-if="errors.includes('dim')">
                             <small v-if="errors.includes('dim')" class="text-danger mt-2 text-left">
                                <i class="fas fa-exclamation-circle"></i>
                                El campo debe contener 6 dígitos
                            </small> 
                        </div>
                        <div :class="isMobile ? 'col-md-3' : 'col-md-3 mt-5'"  v-if="tipo_solicitud == 'Reasignar DI al IDPDV'">
                           <label for="" style="font-size: 17px;" :class="isMobile ? 'mt-5 ml-5' : 'mt-5 ml-5'">Nuevo DI:</label>
                            <b-form-input placeholder="000000" v-model="di_nuevo" class="form-control form-control-lg" maxlength="6" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" type="text" style="border-radius: 30px; background: #fff; border: 1px solid #ccc; font-size: 17px;"/>
                            <small v-if="errors.includes('di_nuevo')" class="text-danger mt-2 text-left">
                                <i class="fas fa-exclamation-circle"></i>
                                Este campo es obligatorio
                            </small> <br v-if="errors.includes('dim_nuevo')">
                             <small v-if="errors.includes('dim_nuevo')" class="text-danger mt-2 text-left">
                                <i class="fas fa-exclamation-circle"></i>
                                El campo debe contener 6 dígitos
                            </small> 
                        </div>
                        <div class="col-md-12">
                            <center>
                                <br v-if="errors.includes('di_repetido')">
                                <small v-if="errors.includes('di_repetido')" class="text-danger mt-2 text-left">
                                    <i class="fas fa-exclamation-circle"></i>
                                    DI actual y Di nuevo no puede ser repetido
                                </small>
                            </center>
                        </div>
                        <div :class="isMobile ? 'col-md-3' : 'col-md-3 mt-5'" v-if="tipo_solicitud == 'Reasignar DI al IDPDV'">
                           <label for="" style="font-size: 17px;" :class="isMobile ? 'mt-5 ml-5' : 'ml-5'">Nombre DI Actual:</label>
                            <b-form-input placeholder="Escribe aquí" v-model="nombre_di"  class="form-control form-control-lg"  type="text" style="border-radius: 30px; background: #fff; border: 1px solid #ccc; font-size: 17px;"/>
                            <small v-if="errors.includes('nombre_di')" class="text-danger mt-2 text-left">
                                <i class="fas fa-exclamation-circle"></i>
                                Este campo es obligatorio
                            </small> 
                        </div>
                        <div :class="isMobile ? 'col-md-3' : 'col-md-3 mt-5'"  v-if="tipo_solicitud == 'Reasignar DI al IDPDV'">
                           <label for="" style="font-size: 17px;" :class="isMobile ? 'mt-5 ml-5' : 'ml-5'">Nuevo Nombre:</label>
                           <b-form-input placeholder="Escribe aquí" v-model="nombre_di_nuevo"  class="form-control form-control-lg"  type="text" style="border-radius: 30px; background: #fff; border: 1px solid #ccc; font-size: 17px;"/>
                            <small v-if="errors.includes('nombre_di_nuevo')" class="text-danger mt-2 text-left">
                                <i class="fas fa-exclamation-circle"></i>
                                Este campo es obligatorio
                            </small> 
                        </div> 
                        <div class="col-md-12">
                            <center>
                                <br>
                                <small v-if="errors.includes('nombre_di_repetido')" class="text-danger mt-2 text-left">
                                    <i class="fas fa-exclamation-circle"></i>
                                    Nombre actual y Nombre nuevo no puede ser repetido
                                </small>
                            </center>
                            <br> 
                        </div>
                        <div class="col-md-6 mt-5">
                            <br>
                            <center> 
                                <label for="" style="font-size: 18px;"  class="ml-5 mt-5">Adjuntar archivo (Soporte / VoBo)</label>
                                <file-pond  ref="pond" style="color:#fff;"
                                            :label-idle="isMobile ? 'Clic aquí para subir tus fotos. Máximo 3 imágenes.' : 'Arrastra o da clic aquí para subir tus fotos. Máximo 3 imagen.'"
                                            v-bind:allow-multiple="true"
                                            accepted-file-types="image/*">

                                    <template v-slot:label></template>

                                </file-pond> 
                                <small class="text-center" style="color:#999;">Formatos .doc .xlxs .pdf, .jpg, .png y .msg</small>
                                <br>
                                <small v-if="errors.includes('imagen')" class="text-danger mt-2 text-left">
                                    <i class="fas fa-exclamation-circle"></i>
                                    Este campo es obligatorio
                                </small> 
                            </center>
                        </div>
                    </div>
                </div>
              </div>
            </div>
            <div class="col-md-7 mt-5 text-center" > 
                <br>    
                <button :disabled="loader" class="btn btn-success float-center btn-sm mt-3 ml-4" type="submit" 
                :style="isMobile ? 'border-radius: 26px; width: 45%; background: #62B22F; border-color: #62B22F; font-size:17px;' 
                :'border-radius: 26px; width: 15%; background: #62B22F; border-color: #62B22F; font-size:17px;'">
                    <span v-if="!loader">
                        Enviar
                    </span>
                    <span v-else>
                    <b-spinner small></b-spinner> Enviando...
                    </span>
                </button>
                <br><br>
            </div> 
        </div>  
    </b-form>  
    <br><br><br><br><br>

  
  </div>
</template>
<script> 
// import moment from 'moment';
import Swal from 'sweetalert2' 
// import $ from 'jquery';  
import 'bootstrap';
import vueFilePond from 'vue-filepond'; 
const FilePond = vueFilePond();
export default {
    name:"Registro", 
    components: { 
      FilePond 
    },
     data() {
        return {
          isMobile: this.$mobile(),
          errors:[],
          loader:false,  
          tipo_solicitud:"",
          idpdv:"",
          nombre_idpdv:"",
          di:"",
          di_nuevo:"",
          nombre_di:"",
          nombre_di_nuevo:""
       }
     },  
     computed: {
        user() {
            return this.$store.getters.getInfoUser;
        },
     },
     methods:{ 
        store(e){
            e.preventDefault();           
            this.errors = [];   
            if(!this.tipo_solicitud){ 
                this.errors.push('tipo_solicitud');  
            }if(!this.idpdv){ 
                this.errors.push('idpdv');  
            }if(!this.nombre_idpdv){ 
                this.errors.push('nombre_idpdv');  
            }if (this.tipo_solicitud  == 'Reasignar DI al IDPDV' && !this.di){ 
                this.errors.push('di');  
            }if (this.tipo_solicitud  == 'Reasignar DI al IDPDV' && this.di.length < 6){ 
                this.errors.push('dim');  
            }if (this.tipo_solicitud  == 'Reasignar DI al IDPDV' && this.di == this.di_nuevo){ 
                this.errors.push('di_repetido');  
            }if (this.tipo_solicitud  == 'Reasignar DI al IDPDV' && !this.di_nuevo){ 
                this.errors.push('di_nuevo');  
            }if (this.tipo_solicitud  == 'Reasignar DI al IDPDV' && this.di_nuevo.length < 6){ 
                this.errors.push('dim_nuevo');  
            }if (this.tipo_solicitud  == 'Reasignar DI al IDPDV' && !this.nombre_di){ 
                this.errors.push('nombre_di');  
            }if (this.tipo_solicitud  == 'Reasignar DI al IDPDV' && this.nombre_di == this.nombre_di_nuevo){ 
                this.errors.push('nombre_di_repetido');  
            }if (this.tipo_solicitud  == 'Reasignar DI al IDPDV' && !this.nombre_di_nuevo){ 
                this.errors.push('nombre_di_nuevo');  
            }if(this.errors.length == 0){
                this.loader = true;
                let model = this.prepareModel();
                this.$api.post("admin/gestor_prueba/store2", model).then(
                response => {
                    this.loader = false;  
                    Swal.fire(
                    "¡List@!",
                    "Se ha enviado correctamente tu solicitud",
                    "success"
                    )
                    this.clear();
                    this.$bus.$emit("menuListadouser");
                    console.log(response)
                },
                error => {
                    this.loader = false;
                    if (error.api) {
                         this.errors = error.api; 
                    }
                }
                )
             }
        },
        prepareModel() { 
             var model = new FormData(); 
                model.append("iduser", this.user.id); 
                model.append("tipo_solicitud", this.tipo_solicitud); 
                model.append("idpdv", this.idpdv); 
                model.append("nombre_idpdv", this.nombre_idpdv); 
                model.append("di", this.di); 
                model.append("di_nuevo", this.di_nuevo);
                model.append("nombre_di", this.nombre_di); 
                model.append("nombre_di_nuevo", this.nombre_di_nuevo);   

                    let files = this.$refs.pond.getFiles();
                    files.forEach((file) => {
                        model.append("archivos[]", file.file);
                    });
                return model;
        }, 
        clear(){
            this.tipo_solicitud = "";
            this.idpdv = "";
            this.nombre_idpdv = "";
            this.di = "";
            this.di_nuevo = "";
            this.nombre_di = ""; 
            this.nombre_di_nuevo = "";  
            this.errors = [];
            this.$refs.pond.removeFiles();
        },    
    } 
}

 
</script>
<style > 
  #pagi a {
    background: none;
    color: #85848A;
    transition: all 300ms ease;
  }


  #inde{
    z-index: 5;
  }

  .table-su{
    background: #CAF5A8;
  }

  #global {
	height: 470px;
	width: 100%; 
	overflow-y: scroll;
}


.filepond--drop-label {
     background-color: #000 !important;
    box-shadow: 0px 10px 10px -6px black;
    cursor: pointer;
    color: #fff; 
}

#filepond--drop-label-96imw404a{
    font-weight: bold; color: #000;
}
</style>